import type * as React from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled from 'styled-components';

export const Wrapper = styled.div<{ bgDesktop?: string; bgMobile?: string }>`
  background-image: ${({ bgMobile }) => `url(${bgMobile})` || 'none'};
  background-position: top center;
  background-repeat: no-repeat;
  background-origin: top;
  background-size: cover;

  ${({ theme }) => theme.breakpoints.up('md')} {
    min-height: 640px;
    background-image: ${({ bgDesktop }) => `url(${bgDesktop})` || 'none'};
  }
`;

export const RightContent = styled.div`
  max-width: 540px;
`;

const ChipWrapper = styled.div`
  background: linear-gradient(
    163.68deg,
    rgba(77, 77, 77, 0.2) 14.79%,
    rgba(145, 145, 145, 0) 141.37%,
    rgba(44, 35, 15, 0.05) 141.37%
  );
  backdrop-filter: blur(80px);
  border-radius: 15px;
`;

export const CustomChip: React.FC<
  React.PropsWithChildren<{ text: string }>
> = ({ text }) => (
  <ChipWrapper className="tw-font-pop text-white font-extrabold text-16 leading-22 w-200 sm:w-160 h-52  flex items-center justify-center text-center">
    {text}
  </ChipWrapper>
);

export const CategoriesIconContainer = styled.div`
  ${({ theme }) => theme.breakpoints.down('sm')} {
    width: calc(100% - 32px);
  }
  ::-webkit-scrollbar {
    height: 4px;
  }
  ::-webkit-scrollbar-thumb {
    background: #c4c4c4;
    border-radius: 4px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #acacac;
  }
`;

export const IconWrapper = styled.span<{ isSelected: boolean }>`
  svg {
    width: 18px;
    height: 18px;
    stroke-width: 2px;
    stroke: ${({ isSelected, theme }) =>
      isSelected ? theme.colors.primary.light : 'white'};
  }
`;
